import { render, staticRenderFns } from "./NewsDetailPage.vue?vue&type=template&id=5e9e5002&scoped=true"
import script from "./NewsDetailPage.vue?vue&type=script&lang=js"
export * from "./NewsDetailPage.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailPage.vue?vue&type=style&index=0&id=5e9e5002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9e5002",
  null
  
)

export default component.exports